import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const DEFAULTS = {
  whatsapp_phone: "908508884865",
  brand_email: "merhaba@yastikmedya.com",
  brand_phone: "+90 (850) 888 48 65",
  brand_address: "Nispetiye Mah. Aytar Cad. Bilgin Sok. Gurup Ap. No:1 D:3/A Beşiktaş/İstanbul",
  instagram_handle: "postunhazir",
  default_currency: "TRY",
  working_hours: "Pzt – Cum 09:30 – 18:30",
};

let _cache = null;
let _inflight = null;
let _cacheTime = 0;
const CACHE_TTL = 60000; // 60 seconds cache TTL - settings refresh every minute

/**
 * Public-safe site settings (whatsapp, email, address, instagram handle…).
 * Cached for 60s so admin changes propagate quickly.
 */
export function useSettings() {
  const [settings, setSettings] = useState(_cache || DEFAULTS);

  useEffect(() => {
    const now = Date.now();
    // Use cache if still fresh
    if (_cache && (now - _cacheTime) < CACHE_TTL) {
      setSettings(_cache);
      return;
    }
    // Invalidate old cache
    _cache = null;
    _inflight = null;
    
    if (!_inflight) {
      _inflight = axios.get(`${API}/settings`)
        .then((r) => { 
          _cache = { ...DEFAULTS, ...(r.data || {}) }; 
          _cacheTime = Date.now();
          return _cache; 
        })
        .catch(() => { _cache = DEFAULTS; _cacheTime = Date.now(); return _cache; });
    }
    _inflight.then((data) => setSettings(data));
  }, []);

  return settings;
}
